import { Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { useUser } from '~/hooks/useUser';

/**
 * View another user's profile by :userId.
 * TODO(backend): Replace useUser mock with useQuery(USER_QUERY) when backend implements.
 */
const ViewUserProfilePage = () => {
  const { user, isLoading } = useUser();

  if (isLoading) {
    return <Typography color="text.secondary">Loading profile…</Typography>;
  }

  if (!user) {
    return (
      <Box>
        <Typography color="text.secondary">User not found.</Typography>
        <Link to="/matters">Back to matters</Link>
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h6">{user.name}</Typography>
      <Typography variant="body2" color="text.secondary">
        {user.email}
      </Typography>
      <Link to="/matters">Back to matters</Link>
    </Box>
  );
};

export default ViewUserProfilePage;
